module.exports = __webpack_public_path__ + "img/Tokio-Marine.cb9a0db7.png";